let _socket = null;
let _socketBoardId = null;
let _socketQuestionId = null;

const WC_BASE = process.env.REACT_APP_WEB_SOCKET_URL;
if (!WC_BASE) {
  console.error(
    "CODING REACT_APP_WEB_SOCKET_URL is not set. " +
      "Check your .env file uses the REACT_APP_ prefix and that the dev " +
      "server was restarted after editing .env.",
  );
}
export function getCodingPath(boardId = "coding-1", questionId) {
  const meetingId = sessionStorage.getItem("meetingId");
  const interviewId = sessionStorage.getItem("interviewId");
  const companyId = sessionStorage.getItem("companyId");

  if (!meetingId || !interviewId || !companyId) {
    console.error("[Coding] Missing session values —", {
      meetingId,
      interviewId,
      companyId,
    });
  }

  return `api/ws/coding/${meetingId}/${boardId}/${interviewId}/${questionId}/${companyId}`;
}

function attachEventShim(ws) {
  ws._listeners = new Map();
  ws._sendQueue = [];

  const flushQueue = () => {
    while (ws._sendQueue.length) {
      ws.send(ws._sendQueue.shift());
    }
  };
  ws.addEventListener("open", flushQueue);

  ws.on = (event, cb) => {
    if (!ws._listeners.has(event)) ws._listeners.set(event, new Set());
    ws._listeners.get(event).add(cb);
  };

  ws.off = (event, cb) => {
    ws._listeners.get(event)?.delete(cb);
  };

  ws.emit = (event, data = {}) => {
    const payload = JSON.stringify({ event, ...data });
    if (ws.readyState === WebSocket.OPEN) {
      ws.send(payload);
    } else if (ws.readyState === WebSocket.CONNECTING) {
      ws._sendQueue.push(payload);
      console.warn(`[Coding] Queuing "${event}" — socket still connecting`);
    } else {
      console.warn(
        `[Coding] Cannot emit "${event}" — socket is ${
          ws.readyState === WebSocket.CLOSING ? "closing" : "closed"
        }`,
      );
    }
  };

  ws.connect = () => {};

  ws.onmessage = (e) => {
    let parsed;
    try {
      parsed = JSON.parse(e.data);
    } catch {
      console.warn("[Coding] Non-JSON message ignored:", e.data);
      return;
    }
    const { event, data } = parsed || {};
    ws._listeners.get(event)?.forEach((cb) => cb(data));
  };
}

export function resetCodingSocket() {
  if (_socket) {
    try {
      _socket.onmessage = null;
      if (
        _socket.readyState === WebSocket.OPEN ||
        _socket.readyState === WebSocket.CONNECTING
      ) {
        _socket.close();
      }
    } catch (err) {
      console.warn("[Coding] Error closing socket during reset:", err);
    }
  }
  _socket = null;
  _socketBoardId = null;
  _socketQuestionId = null;
}

export function getCodingSocket(boardId = "coding-1", questionId, skipReconnect = false) {
  if (!questionId) {
    console.log(
      "[Coding] Delaying socket connection — questionId is null/undefined",
    );
    return null;
  }
  const needsNewSocket =
    !_socket ||
    (!skipReconnect && _socket.readyState === WebSocket.CLOSED) ||
    _socketBoardId !== boardId ||
    _socketQuestionId !== questionId;

  if (needsNewSocket) {
    // resetCodingSocket();

    const socketUrl = `${WC_BASE}${getCodingPath(boardId, questionId)}`;
    console.log("[Coding] Connecting to:", socketUrl);

    _socket = new WebSocket(socketUrl);
    _socketBoardId = boardId;
    _socketQuestionId = questionId;
    attachEventShim(_socket);

    _socket.addEventListener("open", () => console.log("✅ Coding Connected"));
    _socket.addEventListener("error", (err) =>
      console.log("❌ CONNECT ERROR", err),
    );
    _socket.addEventListener("close", (e) =>
      console.log("❌ DISCONNECTED", e.code, e.reason),
    );
  }
  return _socket;
}
